import styled from '@emotion/styled';

export const ModalStyled = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const ButtonSection = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 32px;
  gap: 12px;
  button {
    width: 100%;
  }
`;
